export default __webpack_public_path__ + "static/media/03.d6ae5b0d.png";